import CardTitle from "./CardTitle";
import styled from "styled-components";

interface Props {
  title: string;
  value: string;
}

const Box = styled.div`
  display: flex;
  column-gap: 1.5rem;
  align-items: center;

  input {
    width: 100%;
    margin: 0.5rem 0;
    padding: 0.5rem;
    font-size: 0.875rem;
    border: 1px solid #9c9c9c;
    border-radius: 0.25rem;

    :disabled {
      color: #777777;
      background: #eeeeee;
    }
  }

  .link-input {
    display: block;
    width: 100%;
    margin: 0.5rem 0;
    padding: 0.5rem;
    font-size: 0.875rem;
    border-radius: 0.25rem;
    background-color: #ffffff;
    color: #044dac;
    text-decoration: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
    cursor: pointer;

    &:hover {
      background-color: #f8f9fa;
      text-decoration: underline;
    }
  }
`;

const LinkField = ({ title, value }: Props) => (
  <Box>
    {value ? (
      <>
        <CardTitle title={title} />
        <a
          href={value}
          target="_blank"
          rel="noopener noreferrer"
          className="link-input"
        >
          {"바로 가기"}
        </a>
      </>
    ) : (
      <></>
    )}
  </Box>
);

export default LinkField;
